<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-3"><span class="CharOverride-6">JIM HARRISON</span></p>
<p class="HT ParaOverride-3"><span class="CharOverride-7">Legends of</span></p>
<p class="HT"><span class="CharOverride-7">the Fall</span></p>
<p class="BT1stpara ParaOverride-4"><img alt="" class="_idGenObjectAttribute-1" src="image/V-1.png"/></p>
<p class="BT1stpara ParaOverride-1">Grove Press</p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-8">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4481_eBook2.vue?5b972e82